'use client';

import { useState } from "react";
import styles from "./LazyGoogleMap.module.css";

const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3547.410174818486!2d106.68744887451673!3d10.733260859989516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752fbaee249739%3A0x4485210532f2e667!2zMTk0IMSQLiBz4buRIDcsIEtodSBkw6JuIGPGsCBUcnVuZyBTxqFuLCBCw6xuaCBDaMOhbmgsIEjhu5MgQ2jDrSBNaW5oLCBWaeG7h3QgTmFt!5e1!3m2!1svi!2s!4v1745833490448!5m2!1svi!2s";

const MAP_EXTERNAL_URL =
  "https://www.google.com/maps/search/?api=1&query=194+đường+số+7,+Khu+dân+cư+Trung+Sơn,+xã+Bình+Hưng,+huyện+Bình+Chánh,+TPHCM";

type LazyGoogleMapProps = {
  iframeClassName?: string;
  ariaLabel?: string;
};

export default function LazyGoogleMap({
  iframeClassName,
  ariaLabel = "Bản đồ vị trí công ty SDTC",
}: LazyGoogleMapProps) {
  const [isInteractive, setIsInteractive] = useState(false);

  return (
    <div className={styles.mapWrapper} aria-live="polite">
      {!isInteractive && (
        <div className={styles.placeholder} role="status">
          <p className={styles.placeholderTitle}>Bản đồ Google Maps</p>
          <p className={styles.placeholderDescription}>
            Chúng tôi chỉ tải bản đồ khi bạn cho phép để tránh cookie từ bên thứ ba.
          </p>
          <div className={styles.actions}>
            <button
              type="button"
              className={styles.loadButton}
              onClick={() => setIsInteractive(true)}
              aria-label="Tải Google Maps bên trong trang"
            >
              Hiển thị bản đồ
            </button>
            <a
              href={MAP_EXTERNAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.externalLink}
              aria-label="Mở Google Maps trong tab mới"
            >
              Mở trong tab mới
            </a>
          </div>
        </div>
      )}

      {isInteractive && (
        <iframe
          src={MAP_EMBED_URL}
          className={`${styles.mapFrame} ${iframeClassName ?? ""}`.trim()}
          title={ariaLabel}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      )}
    </div>
  );
}

